/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";


export const TeamsThemes = {
    contrast: "constrast",
    dark: "dark",
    default: "default"
};

//export const ISLOCAL = false;
export const ISLOCAL = window.location.hostname == "localhost" ? true : false;
const APILOCAL = {
    resourceUri: "https://localhost:44325/",
    resourceScopes: ["api://a769a7c7-9646-4094-a044-863e5562b457/access_as_user"]
}

const APIPROD = {
    resourceUri: "https://api.tollringhub.com/",
    resourceScopes: ["api://webapp.tollringhub.com/15918f10-56f8-4f79-a375-ed92f45f6742/access_as_user"]
}

export const apiConfig = ISLOCAL ? APILOCAL : APIPROD;

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
// Coordinates and required scopes for your web API

/** 
 * Scopes you enter here will be consented once you authenticate. For a full list of available authentication parameters, 
 * visit https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const loginRequest = {
    scopes: ["openid", "profile", "offline_access", ...apiConfig.resourceScopes]
}

// Add here scopes for access token to be used at the API endpoints.
export const tokenRequest = {
    scopes: [...apiConfig.resourceScopes]
}

// Add here scopes for silent token request
export const silentRequest = {
    scopes: ["openid", "profile", ...apiConfig.resourceScopes]
}

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
    scopes: ["User.Read"]
};

const MSALCONFIGLOCAL = {
    clientId: "a769a7c7-9646-4094-a044-863e5562b457",
    authority: "https://login.microsoftonline.com/9a4c70c3-ceef-4b3f-84c0-c728cb9a5fa3",
    //redirectUri: window.location.origin,
    redirectUri: "http://localhost:3000/",
    responseMode: 'form_post',
    responseType: 'token+id_token'
}

const MSALCONFIGPROD = {
    clientId: "15918f10-56f8-4f79-a375-ed92f45f6742",
    authority: "https://login.microsoftonline.com/9a4c70c3-ceef-4b3f-84c0-c728cb9a5fa3",
    //redirectUri: window.location.origin,
    redirectUri: "https://webapp.tollringhub.com/auth/redirect.html",
    audience: "api://webapp.tollringhub.com/15918f10-56f8-4f79-a375-ed92f45f6742",
    responseMode: 'form_post',
    responseType: 'token+id_token'
}

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */

export const msalConfig = {
    auth: ISLOCAL ? MSALCONFIGLOCAL : MSALCONFIGPROD,
    cache: {
        cacheLocation: "localStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            }
        }
    }
};